import React, { Component } from 'react';

import classNames from 'classnames';
import { Dropdown, DropdownItem } from 'components/dropdown';
import { Grid } from 'components/grid';
import SearchInput from 'components/input/search/SearchInput';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import { Labeled } from '../../ClubComponents';

import './SearchInputSelectOptions.scss';

const selectOptionsClass = 'select-input-select-options';

export default class SearchInputSelectOptions extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    fetchData: PropTypes.func,
    handleClose: PropTypes.func,
    handleOpen: PropTypes.func,
    loading: PropTypes.bool,
    numberOfElements: PropTypes.number,
    onClean: PropTypes.func,
    onChange: PropTypes.func,
    showOptions: PropTypes.bool,
    t: PropTypes.func,
    totalElements: PropTypes.number
  };

  DropdownRef = React.createRef();
  SearchInputRef = React.createRef();

  constructor(props) {
    super(props);

    this.cleanData = this.cleanData.bind(this);
  }

  cleanData() {
    const { fetchData, onClean } = this.props;
    const value = '';

    this.SearchInputRef.current.cleanValue();
    this.DropdownRef.current.handleClose();

    fetchData(value);
    onClean && onClean();
  }

  get inputResultTitle() {
    const { numberOfElements, totalElements } = this.props;

    return (
      <I18n
        label="community.input_header_exhibition"
        data={{ numberOfElements, totalElements }}
      />
    );
  }

  get dropdownToggle() {
    const { disabled, fetchData, showOptions, loading } = this.props;
    const inputClass = classNames({
      [`${selectOptionsClass}__search--open`]: showOptions
    });

    return (
      <SearchInput
        autoComplete="off"
        className={inputClass}
        disabled={disabled}
        hasClean
        icon="search"
        loading={loading}
        maxLength="120"
        onChange={fetchData}
        onClean={this.cleanData}
        placeholder="users_manager.users_list.filter.input"
        ref={this.SearchInputRef}
      />
    );
  }

  render() {
    const { children, className, showOptions } = this.props;

    const componentClass = classNames(selectOptionsClass, className);

    return (
      <div className={componentClass}>
        <Labeled
          data-test="c-comment-filter-user"
          mode={Labeled.MODE.SMALL}
          label={<I18n html label="community.search" />}
        >
          <Dropdown
            dropdownMenuMaxHeight={null}
            dropdownToggle={this.dropdownToggle}
            ref={this.DropdownRef}
          >
            {showOptions && (
              <DropdownItem>
                <Grid nopadding>
                  <div className={`${selectOptionsClass}__result`}>
                    <div className={`${selectOptionsClass}__result__header`}>
                      <div
                        className={`${selectOptionsClass}__result__header__title`}
                      >
                        {this.inputResultTitle}
                      </div>
                    </div>

                    {children}
                  </div>
                </Grid>
              </DropdownItem>
            )}
          </Dropdown>
        </Labeled>
      </div>
    );
  }
}
